"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _pickup = require("@/api/pickup");
var _vuePropertyDecorator = require("vue-property-decorator");
var _AddressModal = _interopRequireDefault(require("./components/AddressModal.vue"));
var PickupAddressTable = /*#__PURE__*/function (_Vue) {
  function PickupAddressTable() {
    var _this;
    (0, _classCallCheck2.default)(this, PickupAddressTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, PickupAddressTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listQuery", {
      page: 1,
      limit: 10,
      search: ""
    });
    (0, _defineProperty2.default)(_this, "tableData", []);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(PickupAddressTable, _Vue);
  return (0, _createClass2.default)(PickupAddressTable, [{
    key: "created",
    value: function created() {
      this.getTableData();
    }
  }, {
    key: "getTableData",
    value: function () {
      var _getTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _pickup.pickUpApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
                type: this.type
              }));
            case 2:
              res = _context.sent;
              this.tableData = res.data.pickUps;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.addressModal.handleUpdate(row);
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PickupAddressTable.prototype, "type", void 0);
PickupAddressTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    AddressModal: _AddressModal.default
  }
})], PickupAddressTable);
var _default = exports.default = PickupAddressTable;